// StrengthStats.js
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { primaryColor } from "../../../../Constants/Colors";
import { strengthStatsContent } from "../../../../Constants/content";


const StrengthStats = () => {
  return (
    <div style={{ padding: "50px 0", backgroundColor: "#fff" }}>
      <Container>
        <Row className="align-items-center">
          {/* Left Column */}
          <Col md={6}>
            <h2 style={{ color: "#009fe3", fontWeight: "bold" }}>
              {strengthStatsContent[0]}
            </h2>
            <p className="text-muted mt-3">
              {strengthStatsContent[1]}
            </p>
          </Col>

          {/* Right Column - 2x2 Grid */}
          <Col md={6}>
            <Row>
              {/* Top Left */}
              <Col
                xs={6}
                className="text-center py-4"
                style={{
                  borderRight: `1px solid ${primaryColor}`,
                  borderBottom: `1px solid ${primaryColor}`,
                }}
              >

                <h2 style={{ color: "#009fe3", fontWeight: "bold" }}>{strengthStatsContent[2]}</h2>
                <p className="text-muted mb-0">{strengthStatsContent[3]}</p>
              </Col>

              {/* Top Right */}
              <Col
                xs={6}
                className="text-center py-4"
                style={{
                  borderBottom: `1px solid ${primaryColor}`,
                }}
              >

                <h2 style={{ color: "#009fe3", fontWeight: "bold" }}>{strengthStatsContent[4]}</h2>
                <p className="text-muted mb-0">{strengthStatsContent[5]}</p>
              </Col>

              {/* Bottom Left */}
              <Col
                xs={6}
                className="text-center py-4"
                style={{
                  borderRight: `1px solid ${primaryColor}`,
                }}
              >


                <h2 style={{ color: "#009fe3", fontWeight: "bold" }}>{strengthStatsContent[6]}</h2>
                <p className="text-muted mb-0">{strengthStatsContent[7]}</p>

              </Col>

              {/* Bottom Right */}
              <Col xs={6} className="text-center py-4">

                <h2 style={{ color: "#009fe3", fontWeight: "bold" }}>{strengthStatsContent[8]}</h2>
                <p className="text-muted mb-0">{strengthStatsContent[9]}</p>

              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default StrengthStats;
